<template>
  <div class="flex gap-2 w-full">
    <span v-if="label" class="title">{{ label }}</span>
    <div class="flex-1 flex flex-wrap items-center gap-5">
      <div>
        <input type="checkbox" id="all" v-model="checkAll" @click="onClickAll" />
        <label for="all" class="select-none">전체</label>
      </div>

      <div v-for="item in checkItems" :key="item.value" class="relative flex items-center" :class="[childOpenValue === item.value && 'z-10']">
        <div>
          <input type="checkbox" :id="item.value" v-model="checked" :value="item.value" @click="() => onClickItem(item)" />
          <label :for="item.value" class="select-none"
            ><span>{{ item.label }}</span></label
          >
        </div>

        <img
          v-if="!!item.children && 0 < item.children.length"
          src="@/assets/icons/triangle_down.svg"
          class="w-6 h-6 mx-auto duration-200 cursor-pointer"
          :style="{ transform: childOpenValue === item.value ? 'rotate(180deg)' : 'rotate(0deg)' }"
          @click="() => childOpen(item.value)"
        />
        <div v-if="childOpenValue === item.value" class="child-container flex flex-col gap-3" @click.stop>
          <div v-for="child in item.children" :key="child.value">
            <input type="checkbox" :id="child.value" v-model="checked" :value="child.value" @click.stop="() => onClickItemChild(item, child.value)" />
            <label :for="child.value" class="select-none"
              ><span>{{ child.label }}</span></label
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import HttpRequest from "@/util/HttpRequest";

export default {
  name: "SearchNavCompanyIds",
  props: {
    label: { type: String, default: "관련부서" },
    value: Array,
    name: {
      type: String,
      default: "companies",
    },
  },
  computed: {
    projectId() {
      return Number(this.$route.params.proj_id);
    },
    boardSlug() {
      return `board-${this.$route.params.boardId}`;
    },
    checkAll: {
      get() {
        return this.checkOriginIds.length === this.checked.length;
      },
      set() {},
    },
    getCompanies() {
      const query = this.$route.query;
      if (query[this.name]) {
        try {
          return query[this.name];
        } catch (e) {}
      }
      return this.checked;
    },
  },
  watch: {
    value: {
      handler(value) {
        if (this.isUserClick) this.checked = value;
      },
    },
    checked: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  data() {
    return {
      checkOriginIds: [],
      checkItems: [],
      checked: [],
      childOpenValue: null,
      // 사용자가 직접 클릭하여 데이터가 바뀔경우 true
      // query로 데이터가 바뀔때 초기화되는 경우가 있어서 추가
      isUserClick: false,
    };
  },
  async created() {
    this.checked = this.getCompanies;
    if (this.projectId === 5) {
      const params = {
        projectId: this.projectId,
      };

      HttpRequest.get("/api/v1/company/descendants", { params }).then((response) => {
        this.checkOriginIds = response.map((_com) => _com.company.id);

        this.checkItems = response.reduce((_pv, _cv) => {
          const _depth = _cv.company_path.split("/").length;
          if (_depth === 3) {
            const children = response.reduce((_childPv, _childCv) => {
              if (3 < _childCv.company_path.split("/").length && _childCv.company_path.startsWith(_cv.company_path)) return [..._childPv, { label: _childCv.company.com_name, value: _childCv.company.id }];
              else return _childPv;
            }, []);
            return [..._pv, { label: _cv.company.com_name, value: _cv.company.id, children }];
          } else {
            return _pv;
          }
        }, []);
      });
    } else {
      await this.$store.dispatch("board/LOAD_BOARD", {
        boardId: this.boardSlug,
      });
      const boardData = this.$store.state.board.boardData;
      if (boardData) {
        this.checkItems = boardData.filter_companies.map((_com) => {
          return { label: _com.com_name, value: _com.id };
        });
        this.checkOriginIds = this.checkItems.map((_c) => _c.value);
      }
    }
  },
  methods: {
    onClickAll() {
      if (this.checkAll) this.checked = [];
      else this.checked = this.checkOriginIds;
    },
    onClickItem(item) {
      this.isUserClick = true;
      if (!!item.children) {
        const ids = item.children.map((_c) => _c.value);
        // 체크 해제 : child id 모두 제거
        if (this.checked.includes(item.value)) {
          this.checked = this.checked.filter((_check) => !ids.includes(_check));
        }
        // 체크 : child id 모두 추가
        else {
          this.checked = [...this.checked, ...ids];
        }
      }
    },
    onClickItemChild(parent, value) {
      this.isUserClick = true;
      // 체크 해제 : parent id 제거
      if (this.checked.includes(value)) {
        this.checked = this.checked.filter((_check) => parent.value !== _check);
      }
      // 체크 : checked에 형제 id 확인 후 모두 체크되어있다면 부모 id 추가
      else {
        const ids = parent.children.map((_c) => _c.value);
        // child id 확인
        const parentCheck = ids.reduce((isChildAll, id) => {
          return isChildAll && [value, ...this.checked].includes(id);
        }, true);
        // 모두 포함되어 있으면 checked에 부모 id 추가
        if (parentCheck) {
          const _checked = [...this.checked, parent.value];
          this.checked = [...new Set(_checked)];
        }
      }
    },
    childOpen(value) {
      if (this.childOpenValue === value) this.childOpenValue = null;
      else this.childOpenValue = value;
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  width: 114px;

  font-weight: 500;
  line-height: 38px;
  text-align: left;
  white-space: nowrap;
}

.child-container {
  position: absolute;
  left: 0;
  bottom: -6px;
  transform: translate(0, 100%);
  width: 160px;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  padding: 10px;
  z-index: 10;
}
input[type="checkbox"] {
  display: none;
}
label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;

  span {
    flex: 1;
  }
}
input[type="checkbox"] + label:before {
  content: "";
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid #b4b4b4;
  border-radius: 2px;
  box-sizing: border-box;
}
input[type="checkbox"]:checked + label:before {
  background-image: url("~@/assets/icons/checked_color_on_200c63.svg");
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: cover;
  border: none;
}
</style>
